import React from 'react';
import Navigation from '../components/Navigation';
import Footer from '../components/Footer';
import Publications from '../components/Publications';
import { affiliations } from '../data/mock';
import { Card, CardContent } from '../components/ui/card';

const PublicationsPage = () => {
  return (
    <div className="min-h-screen bg-white">
      <Navigation />
      
      {/* Page Header */}
      <div className="pt-32 pb-12 px-4 bg-gradient-to-b from-teal-50 to-white">
        <div className="max-w-7xl mx-auto text-center">
          <h1 className="text-5xl md:text-6xl font-bold text-gray-900 mb-6">
            Publications & Research
          </h1>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Extensive contributions to medical literature and advancement of oncology
          </p>
        </div>
      </div>

      {/* Publications Content */}
      <Publications />

      {/* Research Areas */}
      <section className="py-20 px-4 bg-gray-50">
        <div className="max-w-7xl mx-auto">
          <h2 className="text-3xl font-bold text-gray-900 mb-12 text-center">Research Focus Areas</h2>
          
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            <Card>
              <CardContent className="pt-6">
                <h3 className="text-xl font-bold text-gray-900 mb-3">Breast Cancer</h3>
                <p className="text-gray-600">
                  Circulating tumor cells, molecular markers, treatment outcomes, and multidisciplinary management approaches.
                </p>
              </CardContent>
            </Card>

            <Card>
              <CardContent className="pt-6">
                <h3 className="text-xl font-bold text-gray-900 mb-3">Gastrointestinal Cancers</h3>
                <p className="text-gray-600">
                  Biliary tract cancers, cholangiocarcinoma, colorectal cancer molecular oncology, and targeted therapies.
                </p>
              </CardContent>
            </Card>

            <Card>
              <CardContent className="pt-6">
                <h3 className="text-xl font-bold text-gray-900 mb-3">Lung Cancer</h3>
                <p className="text-gray-600">
                  Early detection using AI, treatment strategies, and leading the Lung Ambition Alliance END project.
                </p>
              </CardContent>
            </Card>

            <Card>
              <CardContent className="pt-6">
                <h3 className="text-xl font-bold text-gray-900 mb-3">Hematological Malignancies</h3>
                <p className="text-gray-600">
                  Hodgkin's lymphoma, multiple myeloma, and other blood cancers treatment protocols.
                </p>
              </CardContent>
            </Card>

            <Card>
              <CardContent className="pt-6">
                <h3 className="text-xl font-bold text-gray-900 mb-3">Head & Neck Cancers</h3>
                <p className="text-gray-600">
                  Salivary gland tumors, oral cancers, and comprehensive management strategies.
                </p>
              </CardContent>
            </Card>

            <Card>
              <CardContent className="pt-6">
                <h3 className="text-xl font-bold text-gray-900 mb-3">Palliative Care Research</h3>
                <p className="text-gray-600">
                  Knowledge and attitudes studies, integrated oncology and palliative care approaches.
                </p>
              </CardContent>
            </Card>
          </div>
        </div>
      </section>

      {/* Professional Affiliations */}
      <section className="py-20 px-4 bg-white">
        <div className="max-w-4xl mx-auto">
          <h2 className="text-3xl font-bold text-gray-900 mb-8 text-center">Professional Affiliations</h2>
          
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            {affiliations.map((affiliation) => (
              <div key={affiliation} className="flex items-start gap-3 p-4 bg-gray-50 rounded-lg">
                <div className="flex-shrink-0 w-2 h-2 bg-teal-700 rounded-full mt-2"></div>
                <p className="text-gray-700">{affiliation}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Notable Publications Section */}
      <section className="py-20 px-4 bg-gradient-to-b from-gray-50 to-white">
        <div className="max-w-4xl mx-auto">
          <h2 className="text-3xl font-bold text-gray-900 mb-8 text-center">Publication Metrics</h2>
          
          <div className="grid grid-cols-2 md:grid-cols-4 gap-6 text-center">
            <div className="bg-white p-6 rounded-xl shadow-md">
              <p className="text-4xl font-bold text-teal-700 mb-2">112+</p>
              <p className="text-gray-600">Papers & Case Reports</p>
            </div>
            <div className="bg-white p-6 rounded-xl shadow-md">
              <p className="text-4xl font-bold text-teal-700 mb-2">12</p>
              <p className="text-gray-600">Review Articles</p>
            </div>
            <div className="bg-white p-6 rounded-xl shadow-md">
              <p className="text-4xl font-bold text-teal-700 mb-2">22+</p>
              <p className="text-gray-600">Journal Reviews</p>
            </div>
            <div className="bg-white p-6 rounded-xl shadow-md">
              <p className="text-4xl font-bold text-teal-700 mb-2">1</p>
              <p className="text-gray-600">Textbook Authored</p>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default PublicationsPage;